import React from "react";
import { AdvantageList } from "../advantage-list";
import "./styles.less";
import { useTranslation } from "react-i18next";
const advantageData = [
  { label: "gateway.features.data1.label", value: "90%" },
  { label: "gateway.features.data2.label", value: "75%" },
  { label: "gateway.features.data3.label", value: "50%" },
];
export const GatewayIntegrationFeature = () => {
  const { t } = useTranslation();
  return (
    <div className="gateway-integration-features">
      <div className="inner">
        <AdvantageList advantageData={advantageData} />
        <div className="feature-item security">
          <div className="feature-img">
            <img
              src="http://files.authing.co/authing-website/gateway-integartion-security-v2.png"
              alt="集成老旧应用实现单点登录"
            />
          </div>
          <div className="feature-content">
            <div className="title">{t("gateway.features.item1.title")}</div>
            <div className="item-warp">
              <div className="sub-title">
                {t("gateway.features.item1.list1.title")}
              </div>
              <div className="descript">
                {t("gateway.features.item1.list1.descript")}
              </div>
            </div>
            <div className="item-warp">
              <div className="sub-title">
                {t("gateway.features.item1.list2.title")}
              </div>
              <div className="descript">
                {t("gateway.features.item1.list2.descript")}
              </div>
            </div>
          </div>
        </div>
        <div className="feature-item framework">
          <div className="feature-content">
            <div className="title">{t("gateway.features.item2.title")}</div>
            <div className="item-warp">
              <div className="descript">
                {t("gateway.features.item2.descript")}
              </div>
            </div>
          </div>
          <div className="feature-img">
            <img
              src={`http://files.authing.co/authing-website/${t(
                "gateway.features.item2.img"
              )}`}
              alt="authing"
            />
          </div>
        </div>
        <div className="feature-item integration">
          <div className="feature-img">
            <img
              src="http://files.authing.co/authing-website/gateway-integartion-integrate-new.png"
              alt="零代码集成单点登录"
            />
          </div>
          <div className="feature-content">
            <div className="title">{t("gateway.features.item3.title")}</div>
            <div className="item-warp">
              <div className="descript">
                {t("gateway.features.item3.descript")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
